var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.63879 4.74308L8.97579 7.88808H11.4068V8.94208H8.75479L7.97279 12.5801H6.83379L7.61579 8.94208H3.84179L3.05979 12.5801H1.92079L2.70279 8.94208H-0.000214841V7.88808H2.92379L3.58679 4.74308H0.934785V3.68908H3.82479L4.60679 7.79629e-05H5.74579L4.96379 3.68908H8.73779L9.51979 7.79629e-05H10.6588L9.87679 3.68908H12.3418V4.74308H9.63879ZM8.49979 4.74308H4.72579L4.06279 7.88808H7.83679L8.49979 4.74308Z",
    fill: "#183243"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreadIcon);
export default __webpack_public_path__ + "static/media/thread_icon.c13e63ffb3a4db491679a5dc86d2c57e.svg";
export { ForwardRef as ReactComponent };